import { defaultFilterDateRange } from '@/shared/utils/date-range';
export const KPI_CHART_TYPES = ['bar', 'line', 'pie', 'doughnut'];
function parseChartColors(color) {
    if (!color)
        return '#888';
    if (color.includes(','))
        return color.split(',').map((c) => c.trim());
    return color;
}
export function apiChartToChartJs(chart) {
    if (!chart)
        return null;
    return {
        labels: chart.labels,
        datasets: chart.datasets.map((ds) => ({
            label: ds.label,
            data: ds.data,
            backgroundColor: parseChartColors(ds.backgroundColor),
            borderColor: parseChartColors(ds.borderColor),
            borderWidth: ds.borderWidth ?? 1,
            fill: chart.type !== 'line',
        })),
    };
}
function buildSummary(agents, distribution) {
    const totalAnswered = distribution.datasets[0]?.data[0] ?? 0;
    const totalUnanswered = distribution.datasets[0]?.data[1] ?? 0;
    const totalCalls = totalAnswered + totalUnanswered;
    const totalDurationSeconds = agents.reduce((sum, row) => sum + row.totalCallDuration, 0);
    const overallAnswerRate = totalCalls > 0 ? (totalAnswered / totalCalls) * 100 : 0;
    return {
        totalCalls,
        totalAnswered,
        totalUnanswered,
        formattedTotalDuration: formatDurationFromSeconds(totalDurationSeconds),
        overallAnswerRate,
    };
}
export function mapKpiDashboardResponse(raw) {
    return {
        summary: buildSummary(raw.agents, raw.callDistributionChart),
        agents: raw.agents,
        callStatusChart: raw.callStatusChart,
        performanceChart: raw.performanceChart,
        callDistributionChart: raw.callDistributionChart,
        hourlyDistributionChart: raw.hourlyDistributionChart,
        queueComparisonChart: raw.queueComparisonChart,
        satisfactionChart: raw.satisfactionChart,
    };
}
export function deriveKpiReference(agents) {
    return {
        agents: [...new Set(agents.map((row) => row.agent))].sort(),
        queues: [...new Set(agents.map((row) => row.queue))].sort(),
        shifts: [...new Set(agents.map((row) => row.shift))].sort(),
        chartTypes: [...KPI_CHART_TYPES],
    };
}
export function defaultKpiDateRange() {
    return defaultFilterDateRange();
}
export function toKpiDateParam(d) {
    if (!d || Number.isNaN(d.getTime()))
        return undefined;
    return d.toISOString();
}
export function formatKpiPercent(n) {
    return new Intl.NumberFormat(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(n);
}
export function formatKpiCount(n) {
    return new Intl.NumberFormat().format(n);
}
export function formatDurationFromSeconds(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return [hours, minutes, seconds].map((n) => String(n).padStart(2, '0')).join(':');
}
export function kpiRateClass(rate) {
    if (rate >= 80)
        return 'text-green-600';
    if (rate >= 60)
        return 'text-yellow-500';
    return 'text-red-600';
}
